export const foodCategoriesList : string[] = ['Meat','Fish','Vegetarian','Vegan','Gluten Free'];    